export default "__VITE_ASSET__dfdf16d6__"